module.exports = __webpack_public_path__ + "img/3-01-05-e-wht.0af20d54.svg";